export default __webpack_public_path__ + "02271ec5cb9f5b4588ac53d7efbe6de8.woff";